import {ApplicationRef, Injectable, inject} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {
  GridResourceStringsEN,
  registerI18n as registerAngularI18n,
  setCurrentI18n as setAngularCurrentI18n
} from '@infragistics/igniteui-angular/core';
import {IgxResourceStringsES} from 'igniteui-angular-i18n';
import {TranslateService} from '@ngx-translate/core';
import {AppInfoService} from './app-info.service';
import localeEN from '@angular/common/locales/en';
import localeES from '@angular/common/locales/es';
import {
  addResourceStrings,
  IgcDockManagerResourceStrings
} from '@infragistics/igniteui-dockmanager';
import {ClsUtil} from '../../util/cls-util';
import {KeyLocalStorage} from '../models/enum/emun-enumeracion';

const dockManagerResourceStringsES: IgcDockManagerResourceStrings = {
  close: 'Cerrar',
  documents: 'Documentos',
  maximize: 'Maximizar',
  minimize: 'Minimizar',
  moreOptions: 'Más opciones',
  pin: 'Anclar',
  moreTabs: 'Más fichas',
  panes: 'Paneles',
  unpin: 'Desanclar'
};

const dockManagerResourceStringsEN: IgcDockManagerResourceStrings = {
  close: 'Close',
  documents: 'Documents',
  maximize: 'Maximize',
  minimize: 'Minimize',
  moreOptions: 'More options',
  pin: 'Pin',
  moreTabs: 'More tabs',
  panes: 'Panes',
  unpin: 'Unpin'
};

@Injectable({
  providedIn: 'root'
})
export class TraduccionService {
  private readonly appRef = inject(ApplicationRef);
  public dmLenguaje: IgcDockManagerResourceStrings;

  constructor() {
    registerLocaleData(localeES);
    registerLocaleData(localeEN);

    registerAngularI18n(IgxResourceStringsES, 'es');
    registerAngularI18n(IgxResourceStringsES, 'es-MX');
    registerAngularI18n(GridResourceStringsEN, 'en');
    registerAngularI18n(GridResourceStringsEN, 'en-US');

    addResourceStrings('es', dockManagerResourceStringsES);
    addResourceStrings('es-MX', dockManagerResourceStringsES);
    addResourceStrings('en', dockManagerResourceStringsEN);
    addResourceStrings('en-US', dockManagerResourceStringsEN);

    GridResourceStringsEN.igx_grid_row_edit_btn_done = 'Apply';
    GridResourceStringsEN.igx_grid_add_row_label = 'ADD RECORD';
    IgxResourceStringsES.igx_grid_row_edit_btn_done = 'Aplicar';
    IgxResourceStringsES.igx_grid_add_row_label = 'AGREGAR REGISTRO';
  }

  public cambiarLenguaje(lenguaje: string, document: Document, translate: TranslateService, infApp: AppInfoService) {
    lenguaje = lenguaje ?? 'es';
    if (!localStorage.getItem(KeyLocalStorage.Lenguaje)) {
      localStorage.setItem(KeyLocalStorage.Lenguaje, lenguaje);
    }
    const igniteLocaleTag = ClsUtil.obtenerLocalGrid();

    document.documentElement.lang = lenguaje;

    setAngularCurrentI18n(igniteLocaleTag);

    infApp.translate = translate;
    translate.use(lenguaje);

    this.dmLenguaje = lenguaje === 'es' ? dockManagerResourceStringsES : dockManagerResourceStringsEN;
  }
}
